export default __webpack_public_path__ + "static/media/trusted.427a2f7e.svg";